import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/SchoolProgram/2024/orientation/1.jpg';
// import p2 from 'assests/Photos/SchoolProgram/2024/orientation/2.jpg';
// import p3 from 'assests/Photos/SchoolProgram/2024/orientation/3.jpg';
// import p4 from 'assests/Photos/SchoolProgram/2024/orientation/4.jpg';
// import p5 from 'assests/Photos/SchoolProgram/2024/orientation/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2024/orientation/6.jpg';


// import p5 from 'assests/Photos/SchoolProgram/2023/Valediction_ceremony/5.jpg';
// import p6 from 'assests/Photos/SchoolProgram/2023/RepublicDay/6.jpg';
// import p7 from 'assests/Photos/SchoolProgram/2023/RepublicDay/7.jpg';
// import p8 from 'assests/Photos/SchoolProgram/2023/RepublicDay/8.jpg';
// import p9 from 'assests/Photos/SchoolProgram/2023/RepublicDay/9.jpg';
// import p10 from 'assests/Photos/SchoolProgram/2023/RepublicDay/10.jpg';


import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2025 } from '../SchoolProgram2023/components';

const Sansad2025 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2025: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2025}/home/events-activities/school-programs/Sansad/1.webp`;
    const p2 = `${config.base_image_url_2025}/home/events-activities/school-programs/Sansad/2.webp`;
    const p3 = `${config.base_image_url_2025}/home/events-activities/school-programs/Sansad/3.webp`;
    const p4 = `${config.base_image_url_2025}/home/events-activities/school-programs/Sansad/4.webp`;
    const p5  = `${config.base_image_url_2025}/home/events-activities/school-programs/Sansad/5.webp`;
    const p6  = `${config.base_image_url_2025}/home/events-activities/school-programs/Sansad/6.webp`;
    const p7  = `${config.base_image_url_2025}/home/events-activities/school-programs/Sansad/7.webp`;
    const p8  = `${config.base_image_url_2025}/home/events-activities/school-programs/Sansad/8.webp`;
    const p9  = `${config.base_image_url_2025}/home/events-activities/school-programs/Sansad/9.webp`;
    const p10 = `${config.base_image_url_2025}/home/events-activities/school-programs/Sansad/10.webp`;
    const p11 = `${config.base_image_url_2025}/home/events-activities/school-programs/Sansad/11.webp`;
   
    const photos = [
         {
  src: p1,
  source: p1,
  rows: 1,
  cols: 1,
},
{
  src: p2,
  source: p2,
  rows: 1,
  cols: 1,
},
{
  src: p3,
  source: p3,
  rows: 1,
  cols: 1,
}, 
{
  src: p4,
  source: p4,
  rows: 1,
  cols: 1,
},
{
  src: p5,
  source: p5,
  rows: 1,
  cols: 1,
},
{
  src: p6,
  source: p6,
  rows: 1,
  cols: 1,
},
{
  src: p7,
  source: p7,
  rows: 1,
  cols: 1,
},
{
  src: p8,
  source: p8,
  rows: 1,
  cols: 1,
},
{
  src: p9,
  source: p9,
  rows: 1,
  cols: 1,
},
{
  src: p10,
  source: p10,
  rows: 1,
  cols: 1,
},
{
  src: p11,
  source: p11,
  rows: 1,
  cols: 1,
} 

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                               Sansad
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                  Class: 9 to 12      Date: 12 August 2025
                                </Typography>
                                {/* <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “If you believe in yourself and have dedication and determination and never quit, you'll be a winner. The price of victory is high but so are the rewards.”

                                <br />
                            </Typography> */}

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                On Tuesday, 12 August 2025, National Public School, Yeshwanthpur organised ‘Sansad’, an inter-school Mock Parliament session for students of Classes 9 to 12. The event provided a dynamic platform to simulate real parliamentary proceedings, aiming to foster active citizenship and encourage students to engage meaningfully with democratic processes.
                                <br></br>
                                The session commenced with an introductory statement, setting the tone for a day of structured debate and discussion. This was followed by a question hour, where members directed queries to ministers, mirroring actual parliamentary protocols. The zero hour saw the discussion of pressing contemporary issues, where participants spoke with clarity, passion, and conviction.  
                                <br></br>
                                The central focus of the debate was the motion: "Reforming the Official Secrets Act, 1923." Both the Ruling and Opposition parties presented their perspectives with depth and thorough research. Members engaged in rigorous debate, questioned each other’s viewpoints, highlighted the strengths and weaknesses of the proposed reforms and participated in voting of the bill.
                               <br></br>
                               The event was a testament to the students’ leadership, teamwork, and strategic thinking. It reinforced classroom learning by bringing theoretical knowledge to life and allowed every participant to immerse themselves in the essence of democratic governance.
                              <br></br>
                               ‘Sansad’ was not just an academic exercise but a step towards nurturing informed citizens.
                               <br></br>
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “ The strength of a democracy lies in the ability of its citizens to question, engage, and actively participate in shaping its future.”

                                <br />
                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2025/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default Sansad2025;